import type { PlotType } from "components/charts/modern/inputs/PlotTypeSelector";
import { atom } from "jotai";

export const OPERATING_INDICATOR_TYPE_ATOM = atom<string | null>(null);
export const OPERATING_SELECTED_YEAR_ATOM = atom<number | null>(null);
export const OPERATING_PLOT_TYPE = atom<PlotType>("pie");
